import { render, staticRenderFns } from "./LomTrainingQuestionList.vue?vue&type=template&id=65f2c154"
import script from "./LomTrainingQuestionList.vue?vue&type=script&lang=js"
export * from "./LomTrainingQuestionList.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingQuestionList.vue?vue&type=style&index=0&id=65f2c154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports